import React from 'react';
import MeetingLayout from './MeetingLayout';

const StudentMeeting = ({ attendees, tutorStream, meetingStarted, handleStreamStudentAudio, handleStreamStudentCam }) => (
    <MeetingLayout
        attendees={attendees}
        tutorStream={tutorStream}
        meetingStarted={meetingStarted}
        audience="student"
        handleStudentAudio={handleStreamStudentAudio}
        handleStudentCam={handleStreamStudentCam}
    />
);

export default StudentMeeting;
